import { useEffect, useState, useRef } from "react";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom";
import { HiOutlineShoppingCart } from "react-icons/hi";
import { BsBookmarkHeart, BsFillBookmarkHeartFill } from "react-icons/bs";
import axios from "axios";
import { useSnackbar } from "notistack";
import Navbar from "../components/navbar/Navbar";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import {
  postAddProductToCartService
} from "../api/apiServices";
import BackButton from "../components/BackButton";

const ProductDetails = () => {
  const location = useLocation();
  const { productId } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState({});
  const [imagesArray, setImagesArray] = useState([]);
  const auth = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const [activeIndex, setActiveIndex] = useState(null);
  const [qty, setQty] = useState(1);
  const galleryRef = useRef(null);

   const handleImageClick = () => {
     if (galleryRef.current) {
       galleryRef.current.fullScreen();
     }
   };

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const fromSection = location.state?.fromSection;

  // Derive banner/section name from product tag (and condition/category as fallback)
  const getBannerName = () => {
    const tagRaw = product?.tag;
    const tag = typeof tagRaw === "string" ? tagRaw.trim() : tagRaw;
    const conditionType = product?.condition_type;
    const productType = product?.product_type;

    if (tag) {
      switch (tag) {
        case "Exclusive":
          return "Exclusive";
        case "Coming Soon":
          return "Coming Soon";
        case "Bestseller":
          return "Bestseller";
        case "On Discount":
          return "On Discount";
        case "Prebooking":
          return "Prebooking";
        case "Latest Releases":
          return "Latest Release";
        case "Rare":
          return "Rare";
        case "Premium":
          return "Premium";
        case "Combo":
          return "Combinations Titles";
        default:
          break;
      }
    }

    // Preowned section is driven by condition_type
    if (conditionType === "Preowned") {
      return "Pre-Owned";
    }

    // Liquids section
    if (productType === "Liquid") {
      return "Cleaner";
    }

    // Fallback to any section name passed via navigation state
    if (fromSection) return fromSection;

    return null;
  };

  const bannerName = getBannerName();

  const history = useHistory();

  useEffect(() => {
    if (id) {
      getProduct();
    }
  }, [id]);

  useEffect(() => {
    const max = product?.max_quantity ?? product?.qty_available ?? 0;
    setQty((prev) => (max > 0 && prev > max ? max : prev));
  }, [product?.max_quantity, product?.qty_available]);

  const getProduct = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BASEURL}/admin/product/getproduct`,
        {
          product_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setProduct(res.data.data);

          setImagesArray(
            res.data.data.product_images.map((imageUrl, index) => ({
              original: `https://pancham-bucket.s3.amazonaws.com/${imageUrl}`,
              thumbnail: `https://pancham-bucket.s3.amazonaws.com/${imageUrl}`,
            }))
          );
        } else {
          enqueueSnackbar("Failed", { variant: "error" });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar("Error occurred. Please try again.", {
          variant: "error",
        });
        setLoading(false);
      });
  };

  const addProductToCart = async (product_id) => {
    const data = { product_id: parseInt(product_id), qty };
    postAddProductToCartService(data)
      .then((response) => {
        if (response.data.success) {
          enqueueSnackbar("Product Added to Cart", { variant: "success" });
          window.dispatchEvent(new CustomEvent("cartUpdated"));
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };


 function getProductType(data) {
   const { product_type, type } = data;

   if (product_type === "CD") {
     const cdType = type.cdType;
     const cdTypeKeys = Object.keys(cdType).filter(
       (key) => cdType[key] === true
     );
     if (cdTypeKeys.length > 0) {
       return cdTypeKeys.join(", ") + (cdType.type ? ` ${cdType.type}` : "");
     }
   } else if (product_type === "Casette") {
     return type.casetteType;
   } else if (product_type === "Vinyl Record") {
     const vinylRecordType = type.vinylRecordType;
     const colorPart = vinylRecordType.color ? `${vinylRecordType.color} Record` : "";
     const parts = [vinylRecordType.recordCat1, `${vinylRecordType.rpm} RPM`, colorPart].filter(Boolean);
     return parts.join(" - ");
   }

   return "Type not specified";
 }

  const inStock = product?.qty_available ?? 0;
  const maxAllowed = product?.max_quantity ?? Infinity;
  const effectiveMax = Math.min(maxAllowed, inStock);

  const highlight45Rpm = (text) => {
    if (!text || typeof text !== "string") return text;
    const parts = text.split(/\b(45\s*rpm)\b/gi);
    return parts.map((part, i) =>
      /^45\s*rpm$/i.test(part) ? (
        <span key={i} className="bg-amber-200/80 text-amber-900 font-semibold px-1 rounded">{part}</span>
      ) : (
        part
      )
    );
  };

  const isPreowned = product?.condition_type === "Preowned";
  const isConditionHighlight = isPreowned || product?.condition_type === "New";

  return (
    <>
      <div className="px-[4%] md:px-[10%] pb-2">
        <Navbar />
        <div className="pt-32 sm:pt-28">
          <div className="sticky top-28 sm:top-24 z-[9] -mx-[4%] px-[4%] md:-mx-[10%] md:px-[10%] py-2 sm:py-3 pt-6 md:pt-8 bg-[var(--theme-color)] mb-4">
            <div className="flex items-center justify-between gap-2 sm:gap-3">
              <div className="flex-shrink-0">
                <BackButton />
              </div>
              {bannerName && (
                <div className="flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full bg-amber-50 border border-amber-200 text-amber-800 text-sm sm:text-base font-semibold tracking-wide max-w-[60%] sm:max-w-[320px] ml-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber-500 flex-shrink-0" />
                  <span className="truncate">{bannerName}</span>
                </div>
              )}
            </div>
          </div>
          {product && (
            <>
              <div className="flex justify-center items-center pt-5 sm:pt-3 pb-2">
                <main className="w-full max-w-5xl mx-auto grid grid-rows-1 sm:grid-cols-2 gap-2 sm:gap-10">
                  {imagesArray && (
                    <section className="product-details-gallery relative bg-black/[0.05] p-2 flex items-center justify-center rounded-lg w-full max-w-md sm:max-w-full mx-auto">
                      {/* {isPreowned && (
                        <div className="absolute top-2 right-2 z-9 bg-amber-600 text-white px-3 py-1.5 rounded font-semibold text-sm shadow">
                          Pre-Owned
                        </div>
                      )} */}
                      <ImageGallery
                        ref={galleryRef}
                        items={imagesArray}
                        lazyLoad
                        showPlayButton={false}
                        showFullscreenButton
                        showThumbnails
                        onClick={handleImageClick}
                      />
                    </section>
                  )}

                  <section className="p-4 sm:p-7 rounded-xl shadow-md bg-white flex flex-col gap-4 sm:gap-6">
                    <div>
                      <h1 className="text-2xl sm:text-4xl font-bold text-gray-900">
                        {product?.title}
                      </h1>
                      <p className="text-gray-600 text-sm sm:text-base mt-2">
                        {product?.description && highlight45Rpm(product.description)}
                      </p>
                    </div>

                    {product?.condition_type && (
                      <div className={`rounded-lg border-2 p-3 ${isConditionHighlight ? "bg-amber-50 border-amber-300" : "bg-gray-50 border-gray-200"}`}>
                        <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">Condition</h3>
                        <span className={`font-semibold text-base ${isConditionHighlight ? "text-amber-900" : "text-gray-800"}`}>
                          {product.condition_type === "Preowned" ? "Pre-Owned" : product.condition_type}
                        </span>
                      </div>
                    )}

                    <div className="flex flex-col gap-2">
                      <h2 className="text-lg font-semibold">About Product</h2>
                      {product &&
                        product.product_type === "Liquid" &&
                        product?.details?.some(
                          (detail) =>
                            detail.key !== "" || detail.description !== ""
                        ) && (
                          <>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 sm:gap-x-10 gap-y-2.5 mb-4">
                              {product.details.map((detail, idx) => (
                                <div key={idx} className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                                  <span className="text-gray-500 text-xs sm:text-sm shrink-0">{detail.key}:</span>
                                  <span className="text-gray-900 text-sm break-words flex-1 min-w-0">
                                    {detail.description}
                                  </span>
                                </div>
                              ))}
                            </div>
                            <h2 className="text-lg font-semibold">
                              Instructions for use
                            </h2>
                            <span>
                              1) Clean the record with a dry microfiber cloth to
                              remove excess dry dust .
                            </span>
                            <span>
                              2) Spray this record cleaning liquid nicely and
                              make sure the record gets completely wet .
                            </span>
                            <span>
                              3) After 2-3 minutes , clean the record with a
                              soft cotton cloth . The record will dry in a
                              couple of minutes . will be nice and shiny !
                            </span>
                            <span>
                              4) After 4-5 times cleaning , any kind of dusty
                              record will get clean and shiny . you need not
                              clean the record 4-5 times at once. One rule which
                              i follow - clean the record everytime i play .
                            </span>
                            <span>
                              Following is the link to the youtube video on
                              instructions for use
                              <br />
                              <a
                                className="font-bold text-amber-600 underline"
                                target="_blank"
                                href="https://www.youtube.com/watch?v=8NCPidupldU"
                              >
                                WATCH VIDEO
                              </a>
                            </span>
                          </>
                        )}

                      {product && product.product_type !== "Liquid" && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 sm:gap-x-10 gap-y-2.5">
                          {product.product_type && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Product:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.product_type}</span>
                            </div>
                          )}
                          {product.category && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Category:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.category}</span>
                            </div>
                          )}
                          {product.label && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Label:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.label}</span>
                            </div>
                          )}
                          {product.year && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Year:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.year}</span>
                            </div>
                          )}
                          {getProductType(product) && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Type:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">
                                {highlight45Rpm(getProductType(product))}
                              </span>
                            </div>
                          )}
                          {product.country && product.country.toLowerCase() !== "unknown" && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Country:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{`Made in ${product.country}`}</span>
                            </div>
                          )}
                          {product.language && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Language:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.language}</span>
                            </div>
                          )}
                          {product?.catalogue_number && (
                            <div className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                              <span className="text-gray-500 text-xs sm:text-sm shrink-0">Catalogue Number:</span>
                              <span className="text-gray-900 text-sm break-words flex-1 min-w-0">{product.catalogue_number}</span>
                            </div>
                          )}
                          {isPreowned &&
                            product.condition_details &&
                            product.condition_details.map((detail, index) => {
                              const isCoverOrRecord =
                                detail.key &&
                                (/condition of cover|cover\s*condition/i.test(detail.key) || /condition of record|record\s*condition/i.test(detail.key));
                              return (
                                <div
                                  key={index}
                                  className={`flex flex-wrap gap-1 py-2 sm:col-span-2 ${isCoverOrRecord ? "bg-amber-100 border border-amber-300 rounded-lg px-3 py-2.5 mt-1" : "border-b border-gray-100"}`}
                                >
                                  <span className={`text-sm shrink-0 ${isCoverOrRecord ? "font-semibold text-amber-900" : "text-gray-500"}`}>
                                    {detail.key}:{" "}
                                  </span>
                                  <span className={isCoverOrRecord ? "font-medium text-amber-900" : "text-gray-900"}>{detail.description}</span>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>

                    {product?.tag === "Coming Soon" ? (
                      <div className="rounded-xl border-2 border-dashed border-amber-400 bg-amber-50/50 p-6 text-center shadow-sm">
                        <span className="text-xl font-bold text-amber-800 tracking-wider uppercase block">
                          Coming Soon
                        </span>
                        <p className="text-sm text-amber-700 mt-2 font-medium">
                          This title is not yet available for purchase.
                        </p>
                      </div>
                    ) : (
                      <div className="rounded-xl border border-gray-200 bg-gray-50/80 p-4 sm:p-5 pb-10 sm:pb-5 space-y-4">
                        <div className="flex flex-wrap items-baseline gap-2 gap-y-1">
                          <span className="text-gray-600 text-sm font-medium">Price</span>
                          <span className="text-2xl font-semibold text-amber-600">
                            ₹{product?.selling_price}
                          </span>
                          {(product?.qty_available ?? 0) > 0 && (product?.qty_available ?? 0) < 5 && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-600 text-white">
                              Only {product?.qty_available ?? 0} left
                            </span>
                          )}
                          {(product?.qty_available ?? 0) <= 0 && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-500 text-white">
                              Sold Out
                            </span>
                          )}
                          {(product?.is_courier_charge_free === 1 || product?.is_courier_charge_free === "true" || product?.is_courier_charge_free === true) && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-600 text-white shadow-sm">
                              Free Shipping
                            </span>
                          )}
                        </div>

                        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                          <div className="flex items-center gap-3">
                            <span className="text-gray-600 text-sm font-medium shrink-0">Quantity</span>
                            <div className="flex items-center rounded-lg border border-gray-300 overflow-hidden bg-white shadow-sm">
                              <button
                                type="button"
                                onClick={() => setQty((prev) => Math.max(1, prev - 1))}
                                disabled={qty <= 1 || (product?.qty_available ?? 0) === 0}
                                className="flex items-center justify-center h-10 w-10 bg-amber-600 text-white font-medium hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                              >
                                −
                              </button>
                              <span className="min-w-[2.5rem] h-10 flex items-center justify-center bg-white border-x border-gray-200 text-sm font-medium text-gray-900">
                                {qty}
                              </span>
                              <button
                                type="button"
                                onClick={() => {
                                  if (qty >= effectiveMax) {
                                    if (inStock > 0 && inStock < maxAllowed) {
                                      enqueueSnackbar(`Only ${inStock} remaining`, { variant: "info" });
                                    } else {
                                      enqueueSnackbar(`Max quantity is ${effectiveMax}`, { variant: "info" });
                                    }
                                    return;
                                  }
                                  setQty((prev) => prev + 1);
                                }}
                                disabled={(product?.qty_available ?? 0) === 0}
                                className="flex items-center justify-center h-10 w-10 bg-amber-600 text-white font-medium hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                              >
                                +
                              </button>
                            </div>
                          </div>
                          <button
                            className={`flex items-center justify-center gap-2 w-full sm:w-auto min-h-[44px] px-5 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                              (product?.qty_available ?? 0) <= 0
                                ? "bg-gray-400 text-white cursor-not-allowed"
                                : !userId
                                ? "border-2 border-amber-600 text-amber-700 bg-white hover:bg-amber-50 disabled:cursor-not-allowed"
                                : "bg-amber-600 text-white hover:bg-amber-700 shadow-sm"
                            }`}
                            disabled={(product?.qty_available ?? 0) === 0}
                            onClick={() => {
                              if (!userId) history.push("/login");
                              else if ((product?.qty_available ?? 0) > 0) addProductToCart(product.product_id);
                            }}
                          >
                            {(product?.qty_available ?? 0) <= 0 ? (
                              "Sold Out"
                            ) : !userId ? (
                              "Login to Shop"
                            ) : (
                              <>
                                <HiOutlineShoppingCart className="w-5 h-5" />
                                Add to Cart
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </section>
                </main>
              </div>
              {product && product.product_type !== "Liquid" && (
                <>
                  <section className="p-4 sm:p-5 mt-5 rounded-md shadow-sm bg-white/[0.7] flex flex-col gap-3 sm:gap-5 ">
                    <div className="flex flex-col gap-2  ">
                      <h2 className="  text-lg font-semibold">Artists</h2>
                      <ul className="flex flex-wrap gap-3">
                        <div>
                          {product?.artists?.length > 0 && (
                            <li>
                              <span className="text-gray-500 text-md">
                                Artists:{" "}
                              </span>
                              {product.artists.join(", ")}
                            </li>
                          )}
                          {product?.lyricists?.length > 0 && (
                            <li>
                              <span className="text-gray-500 text-md">
                                Lyricists:{" "}
                              </span>
                              {product.lyricists.join(", ")}
                            </li>
                          )}
                          {product?.music_director?.length > 0 && (
                            <li>
                              <span className="text-gray-500 text-md">
                                Music Directors:{" "}
                              </span>
                              {product.music_director.join(", ")}
                            </li>
                          )}
                        </div>
                      </ul>
                      {product?.details?.some(
                        (detail) =>
                          detail.key !== "" || detail.description !== ""
                      ) && (
                        <>
                          <h2 className="text-lg font-semibold">
                            About Product
                          </h2>
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 sm:gap-x-10 gap-y-2.5">
                            {product.details.map((detail, idx) => (
                              <div key={idx} className="flex flex-wrap gap-1 py-2 border-b border-gray-100">
                                <span className="text-gray-500 text-xs sm:text-sm shrink-0">{detail.key}:</span>
                                <span className="text-gray-900 text-sm break-words flex-1 min-w-0">
                                  {detail.description}
                                </span>
                              </div>
                            ))}
                          </div>
                        </>
                      )}
                    </div>
                  </section>
                  <section className="p-4 sm:p-5 mb-5 px-4 sm:px-10 mt-5 rounded-md shadow-sm bg-white/[0.7] flex flex-col gap-3 sm:gap-5">
                    <div className="space-y-4">
                      <h2 className="text-lg font-semibold">
                        {product.product_type === "Vinyl Record"
                          ? "Records"
                          : product.product_type === "CD"
                          ? "CDs"
                          : "Cassetes"}{" "}
                        ({product?.cd_details?.length})
                      </h2>

                      {product?.cd_details?.map((cd, index) => (
                        <div
                          key={cd?.id}
                          className="border rounded-xl overflow-hidden"
                        >
                          <div
                            className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-4 p-4 cursor-pointer bg-gray-100 transition duration-300 ease-out min-h-[44px] sm:min-h-0"
                            onClick={() => toggleAccordion(index)}
                          >
                            <div className="min-w-0 text-sm sm:text-base">{cd?.name}</div>
                            <div className="flex items-center gap-1 shrink-0 text-sm sm:text-base">
                              <span>{cd?.tracks?.length} Tracks</span>
                              <span aria-hidden>{" >"}</span>
                            </div>
                          </div>

                          <div
                            className={`overflow-hidden transition-max-height duration-300 ease-out ${
                              activeIndex === index ? "" : "max-h-0"
                            }`}
                          >
                            <ul className="p-4">
                              <div>
                                {Object.entries(
                                  cd?.tracks?.reduce((acc, track) => {
                                    const side = track.side || "Unknown";
                                    acc[side] = acc[side] || [];
                                    acc[side].push(track);
                                    acc[side].sort((a, b) => a.index - b.index);
                                    return acc;
                                  }, {}) ?? {}
                                ).map(([side, tracks]) => (
                                  <div key={side} className="mb-5">
                                    <h2 className="mb-2 mt-1 text-md font-semibold">{`Tracks for Side ${side}`}</h2>
                                    <ul>
                                      {tracks.map((track, index) => (
                                        <div key={track.id}>
                                          <h2 className="mt-1 text-md font-semibold">
                                            {index + 1}. {track.title}
                                          </h2>
                                          <ul className="flex flex-wrap gap-3">
                                            <div>
                                              {track.singers.length > 0 && (
                                                <li>
                                                  <span className="text-gray-500 text-md">
                                                    Artists:{" "}
                                                  </span>
                                                  {track.singers.join(", ")}
                                                </li>
                                              )}
                                              {track.lyricists.length > 0 && (
                                                <li>
                                                  <span className="text-gray-500 text-md">
                                                    Lyricists:{" "}
                                                  </span>
                                                  {track.lyricists.join(", ")}
                                                </li>
                                              )}
                                              {track.music_directors.length >
                                                0 && (
                                                <li>
                                                  <span className="text-gray-500 text-md">
                                                    Music Directors:{" "}
                                                  </span>
                                                  {track.music_directors.join(
                                                    ", "
                                                  )}
                                                </li>
                                              )}
                                            </div>
                                          </ul>
                                        </div>
                                      ))}
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            </ul>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductDetails;
